import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { TailSpin } from 'react-loader-spinner';
import { useParams } from 'react-router-dom';
import Category from './Category'
import { Footer } from './components/footer';
import { Header } from './components/header';
import { BaseShelf, Content } from './globalType';
import Subcategory from './Subcategory';
import { getHost } from './utils';

type Props = {
  goToPage: (page: string, content: Content | null) => void;
};

function MainCategory(props:Props) {
  const {goToPage} = props
  const params = useParams()

  const [baseShelf, setBaseShelf] = useState<BaseShelf[]>([])
  const [currentSlug, setCurrentSlug] = useState<string | undefined>(undefined);
  const [currentShelf, setCurrentShelf] = useState<BaseShelf | undefined>(undefined);

  if (currentSlug !== params.shelfSlug) {
    setCurrentSlug(params.shelfSlug)
  }

  useEffect(() => {
    if (currentSlug) {
      fetchBaseMenu(currentSlug)
    }
  }, [currentSlug]);

  const fetchBaseMenu = async (slug:string | undefined) => {
    if (!slug) return;
    try {
      const result = await fetchBaseShelf();
      setBaseShelf(result.data)
      const shelf = result.data.find((s:BaseShelf) => s.setting.shelf_code === slug)
      setCurrentShelf(shelf);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Header goToPage={goToPage} />
      {!baseShelf && !currentShelf && (
        <div className="d-flex justify-content-center align-items-center" style={{height: '100vh'}}>
        <TailSpin color="#00BFFF" height={150} width={150} />
        </div>
      )}
      {currentSlug && currentShelf?.setting.type === 'by_shelfid' && (
        <Category goToPage={goToPage} shelfSlug={currentSlug} />
      )}
      {currentSlug && currentShelf?.setting.type === 'by_cate' && (
        <Subcategory goToPage={goToPage} shelfSlug={currentSlug} />
      )}
      <Footer />
    </>
  )
}

async function fetchBaseShelf() {
  const host = getHost();
  return axios.get(`${host}/api/series-menu`);
}

export default MainCategory;